import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setGetWithdrawalsUser} from '../../store/thunk/setGetWithdrawalsUser';
import TableCasino from './block/table';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, getRows, useStyles} from './helpers';

const BlockWithdrawal = ({login}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [withdrawal, setWithdrawal] = React.useState(false);

    React.useEffect(() => {
        if (withdrawal) {
            dispatch(setGetWithdrawalsUser({
                id: login,
                page: 1,
                rowsPerPage: 5
            }));
        }
    }, [withdrawal, login])

    const withdrawals = useSelector(state => state.users.user_widthdrawals);
    const rows = React.useMemo(() => getRows(withdrawals.data), [withdrawals]);

    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setWithdrawal(!withdrawal)
                }}
            >
                <span
                    className={classes.title}
                >
                    Выводы
                </span>
                {
                    !withdrawal && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    withdrawal && 
                    <ArrowDown className={classes.arrow}/> 
                }        
            </div>
            <div>
                {
                    withdrawal && login &&
                    <TableCasino
                        allPage={withdrawals.count}
                        width={1280}
                        perPage={10}
                        columns={columns}
                        rows={rows}
                        changeRowsPerPage={(v) => dispatch(setGetWithdrawalsUser({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id: login,
                        }))}
                    /> 
                }
            </div>
        </div>
    )
}

export default BlockWithdrawal;